import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import selectHelper from '../../../Helpers/selectHelper';
import QBOInvoiceReportSearchParams from './QBOInvoiceReportSearchParams';
import ClientInvoiceStatusOptionsArray from '../../../Enums/ClientInvoiceStatusOptionsArray';

export default class ExportQBOInvoiceReportWindowDescription {
  static titleForCreate = 'Export QBO Invoice Report';
  static titleForEdit = 'Export QBO Invoice Report';
  static itemType = QBOInvoiceReportSearchParams;
  static serviceFunction = ReportRunnerService.RequestQboInvoiceReport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeId',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'SearchType',
          label: 'Search Using',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ExportQBOInvoiceReportWindowDescription.searchTypeValues(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'NotExportedYet',
          label: 'Not Exported Yet',
          className: 'col-12',
          type: InputTypesEnum.EmptyYesNoSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOInvoiceReportWindowDescription.isExportStatusInputHidden,
        },
        {
          fieldName: 'YrmoList',
          label: 'Revenue Period (yrmo1,yrmo2,...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOInvoiceReportWindowDescription.isYrmoInputHidden,
        },
        {
          fieldName: 'Statuses',
          label: 'Invoice Status',
          className: 'col-12',
          type: InputTypesEnum.MultiChoice,
          selectvalues: ClientInvoiceStatusOptionsArray,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOInvoiceReportWindowDescription.isYrmoInputHidden,
        },
        {
          fieldName: 'InvoiceIdList',
          label: 'Invoices (id1,id2,...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOInvoiceReportWindowDescription.isInvoiceIdInputHidden,
        },
        {
          fieldName: 'FinalizedAfter',
          label: 'Finalized After',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOInvoiceReportWindowDescription.areFinalizedInputsHidden,
        },
        {
          fieldName: 'FinalizedBefore',
          label: 'Finalized Before',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOInvoiceReportWindowDescription.areFinalizedInputsHidden,
        },
      ],
    },
  ];

  static isExportStatusInputHidden(searchItem) {
    if (searchItem.SearchType !== 'Export Status') {
      searchItem.NotExportedYet = null;
      return true;
    }
    return false;
  }

  static isYrmoInputHidden(searchItem) {
    if (searchItem.SearchType !== 'Revenue Periods') {
      searchItem.YrmoList = '';
      return true;
    }
    return false;
  }

  static isInvoiceIdInputHidden(searchItem) {
    if (searchItem.SearchType !== 'Invoice IDs') {
      searchItem.InvoiceIdList = '';
      return true;
    }
    return false;
  }

  static areFinalizedInputsHidden(searchItem) {
    if (searchItem.SearchType !== 'Finalized Before/After') {
      searchItem.FinalizedAfter = null;
      searchItem.FinalizedBefore = null;
      return true;
    }
    return false;
  }

  static searchTypeValues() {
    return selectHelper.generateSelectValues([
      '',
      'Export Status',
      'Revenue Periods',
      'Invoice IDs',
      'Finalized Before/After',
    ]);
  }
}
